import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=1974c6c4&scoped=true&"
import script from "./ResultsView.vue?vue&type=script&lang=js&"
export * from "./ResultsView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/results.css?vue&type=style&index=0&id=1974c6c4&scoped=true&lang=css&"
import style1 from "@/resources/styles/results-animations.css?vue&type=style&index=1&id=1974c6c4&scoped=true&lang=css&"
import style2 from "@/resources/styles/results-synonyms.css?vue&type=style&index=2&id=1974c6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974c6c4",
  null
  
)

export default component.exports